<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title repayment_h1">Details of the repayment plan<span
        class="ask-time">Application time　{{detail.financeRepayDate}}</span></h1>
      <div class="repayment-top">
        <dl class="text-center should-repaymen">
          <dt>Amount payable</dt>
          <dd>${{detail.financeRepayBalanced | addThousandSign(2)}}</dd>
        </dl>
        <ul class="repay-details">
          <li><span>Principal</span><strong>${{detail.financeRepayPrincipal | addThousandSign(2)}}</strong></li>
          <li><span>Consulting fee</span><strong>${{detail.financeRepayFee | addThousandSign(2)}}</strong></li>
          <li><span>Interest</span><strong>${{detail.financeRepayInterest | addThousandSign(2)}}</strong></li>
          <li><span>Total amount of repayment</span><strong>${{detail.financeRepaySum | addThousandSign(2)}}</strong></li>
        </ul>
      </div>
      <div class="repayment-tips">From {{detail.bankAccountInfo}}Automatic deduction</div>
      <repayment-list :infoList="detail" @getRepayList="getData"></repayment-list>
    </div>
  </section>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import RepaymentList from './RepaymentList.vue'

  export default {
    components: {
      RepaymentList
    },
    data () {
      return {
        financePayId: this.$route.params.financePayId,
        financePayPeriod: this.$route.params.financePayPeriod,
        pageCurrent: 1,
        pageSize: 10,
        repayStatusCode: this.$route.params.repayStatusCode
      }
    },
    computed: {
      ...mapGetters({
        detail: types.GET_NO_REPAY_DETAIL
      })
    },
    methods: {
      ...mapActions({
        getRepayPlanDetail: types.GET_REPAY_PLAN_INFO
      }),
      ...mapMutations({
        setRepayDetail: types.SET_NO_REPAY_DETAIL
      }),
      getData (currenPage) {
        if (currenPage) this.pageCurrent = currenPage
        this.getRepayPlanDetail({
          financePayId: this.financePayId,
          financePayPeriod: this.financePayPeriod,
          pageSize: this.pageSize,
          pageCurrent: this.pageCurrent,
          repayStatusCode: this.repayStatusCode
        }).then((res) => {
          if (res.data.code === '0') {
            this.setRepayDetail(res.data.data)
          }
        })
      }
    },
    mounted () {
      this.getData()
    }
  }
</script>
<style lang="scss">
  .ask-time {
    float: right;
    margin-top: 6px;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 10px;
    font-weight: normal;
    color: $lightSilver;
  }

  .repayment-top {
    overflow: hidden;
    background: #F5F7F8;
  }

  .should-repaymen {
    float: left;
    overflow: hidden;
    padding-top: 30px;
    border-radius: 7px;
    width: 417px;
    height: 126px;
    background: $white;

    dt {
      font-size: 18px;
      color: $orange;
      line-height: 34px;
      font-family: "FZLanTingHei_GBK";
    }

    dt:after {
      content: 'Repayment amount';
      display: block;
      color: #3E454D;
      font-size: 13px;
      line-height: 15px;
      font-family: "MyriadPro-Regular";
    }

    dd {
      font-size: 30px;
      color: #59402E;
      line-height: 44px;
      font-family: "MyriadPro-Bold";
    }
  }

  .repay-details {
    float: right;
    border-radius: 7px;
    padding: 13px;
    width: 409px;
    height: 130px;
    background: $white;

    li {
      width: 183px;
      padding-left: 20px;
      height: 64px;
      float: left;
      span {
        display: block;
        height: 26px;
        color: $lightSilver;
        font-size: 12px;
        line-height: 28px;
      }
      strong {
        display: block;
        height: 30px;
        color: $personalCenterTitleBlack;
        font-size: 20px;
        line-height: 28px;
        font-family: "MyriadPro-Bold";
      }
    }
    li:first-child {
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
    }
    li:nth-child(2) {
      border-bottom: 1px solid #eee;
    }
    li:nth-child(3) {
      border-right: 1px solid #eee;
    }
    li:last-child strong {
      color: $personalCenterFormLabel;
    }
  }

  .repayment-tips {
    overflow: hidden;
    margin: 27px 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    text-indent: 30px;
    background: #E6E9EA url('#{$imagePath}/icons/failed_alert_icon.png') no-repeat 8px center;
    background-size: 16px;
    font-family: "FZLanTingHei_GBK";
  }
</style>



// WEBPACK FOOTER //
// RepaymentInfo.vue?b3e10314